<template>
    <div class="input-group mb-0">
        <input
            type="text"
            @keyup.enter="sendMessage"
            class="form-control"
            v-model="currentText"
            :placeholder="placeholder"
        />
        <div
            class="input-group-append"
            :disabled="currentText.length == 0"
            @click="sendMessage"
        >
            <span class="input-group-text"><i class="fa fa-send"></i></span>
        </div>
    </div>
</template>

<script>
import MessagingService from "../../services/messaging-service";
export default {
    props: {
        conversation: Object,
        activeEvent: Object
    },
    data() {
        return {
            currentText: "",
            placeholder: "Type a message"
        };
    },
    methods: {
        sendMessage() {
            if (this.currentText.length < 1) {
                return "";
            }
            const conversationId = this.activeEvent
                ? this.activeEvent.conversationId
                : this.conversation.id;

            MessagingService.conversations.respond(
                conversationId,
                this.currentText
            );
            this.currentText = '';
        }
    }
};
</script>
